<template>
  <Modal :title="$t('recharge.pix.payPix')" name="RECHARGE_BY_PIX_MODAL">
    <template v-slot:body>
      <div class="text-center">
        <p>
          {{ $t('recharge.pix.description') }}
        </p>
        <h6 class="text-uppercase grey--text mb-0">
          Valor:
        </h6>
        <p class="title">
          {{ formatMoney(pixData.value) }}
        </p>
        <img
          v-if="pixData.pix_qrcode_image"
          alt="PIX QR CODE"
          class="mb-5"
          height="auto"
          width="200"
          :src="`data:image/jpeg;base64,${pixData.pix_qrcode_image}`"
        />
      </div>
      <v-textarea
        v-if="pixData.pix_string_code"
        :value="pixData.pix_string_code"
        class="mb-0 body-2"
        hide-details
        readonly
        outlined
      />
    </template>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import { catalogMonetary } from '@/util/catalog'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalRechargeByPix',

  props: {
    pixData: {
      type: Object,
      required: true,
    },
  },

  components: {
    Modal,
  },

  data() {
    return {
      formatMoney: catalogMonetary,
    }
  },

  methods: {
    ...mapActions(['closeModal']),
  },
}
</script>
